module.exports = __webpack_public_path__ + "static/media/Base_Build_Up_Permeable_Concrete.87b78439.pdf";